export default "__VITE_ASSET__CAKN85TH__"